import React, { useState } from "react";
import "./Bookings.css";
import emailjs from "emailjs-com";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
const BookingForms = () => {
    const [formData, setFormData] = useState({
      name: "",

      date: null, // Store as a Date object
      phone: "",
      requirements: "",
      procedure: "", // Added field for procedure selection
    });

    const [responseMessage, setResponseMessage] = useState("");
    const [loading, setLoading] = useState(false); // Loading state

    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    };

    const handleDateChange = (date) => {
      setFormData({ ...formData, date });
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      setLoading(true); // Start loading
      const serviceId = "service_y2wiyv9";
      const templateId = "template_vdgakx6";
      const userId = "gHJShnDhyA9tSUzLk";

      // Convert date to string for sending via EmailJS
      const submissionData = {
        ...formData,
        date: formData.date ? formData.date.toLocaleDateString() : "",
      };

      emailjs
        .send(serviceId, templateId, submissionData, userId)
        .then(
          (result) => {
            setResponseMessage("Your form has been submitted successfully!");
            setFormData({
              name: "",
           
              date: null,
              phone: "",
              requirements: "",
              procedure: "", // Reset procedure field
            });
            toast.success("Your form has been submitted successfully!");
          },
          (error) => {
            setResponseMessage("Failed to submit the form. Please try again.");
            toast.error("Failed to submit the form. Please try again.");
          }
        )
        .finally(() => {
          setLoading(false); // Stop loading
        });
    };

  return (
    <section className="get-surgery-two">
      <div className="get-surgery-two__shape-3 zoom-fade-2">
        <img
          src="https://jetly-html.vercel.app/main-html/assets/images/shapes/get-flight-two-shape-3.png"
          alt=""
        />
      </div>
      <div className="get-surgery-two__shape-4 float-bob-x">
        <img
          // src="https://jetly-html.vercel.app/main-html/assets/images/shapes/get-flight-two-shape-4.png"
          alt=""
        />
      </div>
      <div className="container">
        <div className="get-surgery-two__content-box">
          <div
            className="get-surgery-two__shape-2 wow slideInRight animated"
            data-wow-delay="100ms"
            data-wow-duration="2500ms"
            style={{
              visibility: "visible",
              animationDuration: "2500ms",
              animationDelay: "100ms",
              animationName: "slideInRight",
            }}
          >
            <img src="/Images/form-book.png" alt="" className="float-bob-y" />
          </div>
          <div className="get-surgery-two__inner">
            <div className="get-surgery-two__shape-1 float-bob-x">
              <img
                src="https://jetly-html.vercel.app/main-html/assets/images/shapes/get-flight-two-shape-1.png"
                // src="https://jetly-html.vercel.app/main-html/assets/images/shapes/get-surgery-two-shape-1.png"
                alt=""
              />
            </div>
            <div className="section-title text-left">
              <span className="section-title__tagline">Make Appointment</span>
              <h2 className="section-title__title">
                Experience the Precision of Surgery{" "}
              </h2>
            </div>
            <form
              onSubmit={handleSubmit}
              className="get-surgery__form contact-form-validated"
              noValidate="novalidate"
            >
              <div className="row">
                <div className="col-xl-6 col-lg-6">
                  <div className="get-surgery__form-input-box">
                    <input
                      type="text"
                      name="name"
                      placeholder="Enter Name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6">
                  <div className="get-surgery__form-input-box">
                    <input
                      type="text"
                      name="phone"
                      placeholder="Phone Number"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6">
                  <div className="get-surgery__form-input-box">
                    <DatePicker
                      selected={formData.date}
                      onChange={handleDateChange}
                      dateFormat="yyyy-MM-dd"
                      placeholderText="Select date"
                      className="form-control"
                      required
                    />
                    <div className="get-surgery__icon-box">
                      <i className="far fa-calendar-alt" />
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6">
                  <div className="get-surgery__form-input-box">
                    <select
                      name="procedure"
                      value={formData.procedure}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Category</option>
                      <option value="Rhinoplasty">Rhinoplasty</option>
                      <option value="Septoplasty">Septoplasty</option>
                      <option value="Lipoma">Lipoma</option>
                      <option value="Gynecomastia">Gynecomastia</option>
                      <option value="Ophthalmology">Ophthalmology</option>
                      <option value="Lasik surgery">Lasik surgery</option>
                      <option value="Cataract surgery">Cataract surgery</option>
                      <option value="ICL (implantable collamer lens) treatment">
                        ICL (implantable collamer lens) treatment
                      </option>
                      <option value="Glaucoma treatment">
                        Glaucoma treatment
                      </option>
                      <option value="Corneal surgery">Corneal surgery</option>
                      <option value="Pediatrics Eye care">
                        Pediatrics Eye care
                      </option>
                      <option value="RLE (Refractive Lens Exchange)">
                        RLE (Refractive Lens Exchange)
                      </option>
                      <option value="Hair transplant">Hair transplant</option>
                      <option value="Skin">Skin</option>
                      <option value="Face">Face</option>
                      <option value="Body">Body</option>
                      <option value="Breast (implant)">Breast (implant)</option>
                      <option value="Gynaecology">Gynaecology</option>
                      <option value="Liposuction">Liposuction</option>
                    </select>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6">
                  <div className="get-surgery__form-input-box">
                    <input
                      type="text"
                      name="requirements"
                      placeholder="Your Message"
                      value={formData.requirements}
                      onChange={handleChange}
                      rows={3}
                      required
                    />
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6">
                  <div className="get-surgery__form-input-box">
                    <button
                      type="submit"
                      className="thm-btn get-surgery__btn"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <p className="get-surgery__content-text">
              {" "}
              <span>*</span> After sending request. We’ll contact you for more
              details.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookingForms;
